var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":"","color":"transparent"}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.title,staticClass:"my-2",attrs:{"text":""}},[_c('a',{staticClass:"font-weight-light text-capitalize",attrs:{"href":link.url}},[_vm._v(_vm._s(link.title))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }